import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { trackRetailersFilterClearClick } from "@faire/web-api--source/events/retailers/click/filterClear";
export var useClearCategoryPageFilters = function() {
    var clearAllFilters = useFilterStore([]).clearAllFilters;
    return function() {
        trackRetailersFilterClearClick(FilterName.LOGGED_IN_CATEGORY, "no_results_clear_all", "");
        clearAllFilters();
    };
};
